function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.97206 1.76786H5.77564C5.88367 1.76786 5.97206 1.67946 5.97206 1.57143V1.76786H13.4363V1.57143C13.4363 1.67946 13.5247 1.76786 13.6328 1.76786H13.4363V3.53571H15.2042V1.57143C15.2042 0.704688 14.4995 0 13.6328 0H5.77564C4.90889 0 4.20421 0.704688 4.20421 1.57143V3.53571H5.97206V1.76786ZM18.3471 3.53571H1.06135C0.626751 3.53571 0.275635 3.88683 0.275635 4.32143V5.10714C0.275635 5.21518 0.364028 5.30357 0.472063 5.30357H1.9551L2.56157 18.1451C2.60086 18.9824 3.29327 19.6429 4.13055 19.6429H15.2779C16.1176 19.6429 16.8076 18.9848 16.8468 18.1451L17.4533 5.30357H18.9364C19.0444 5.30357 19.1328 5.21518 19.1328 5.10714V4.32143C19.1328 3.88683 18.7817 3.53571 18.3471 3.53571ZM15.0888 17.875H4.31961L3.72541 5.30357H15.683L15.0888 17.875Z",
  fill: "white"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4cfd972b.svg";
export { ForwardRef as ReactComponent };